import SpinnerController from '../SpinnerController'
import messageResource from '../messageResource'
import ClassicBridge from '../next/ClassicBridge'
import Spinner from "./../spin.min"

const INDICATION_DELAY_MS = 3000

function indicateExportingOnButton(button) {
    var content = button.html()
    var spinner = new Spinner( { ...SpinnerController.getDefaultSettings(), scale: 0.5 })
    spinner.spin()

    button.addClass("exportInProgress")
    button.empty()
    button.append("<span class='exportSpinner'></span>")
    button.append("<span class='exportProcessingLabel'></span>")
    button.find(".exportSpinner").append(spinner.el)
    button.find(".exportProcessingLabel").append(messageResource.getMessage("report.config.export.exporting"))
    ClassicBridge.showSuccessToast(messageResource.getMessage("report.config.export.toast"))

    setTimeout(() => {
        button.empty()
        button.removeClass("exportInProgress")
        button.append(content)
    }, INDICATION_DELAY_MS)
}

export default indicateExportingOnButton



// WEBPACK FOOTER //
// ./web/js/reports/indicateExportingOnButton.js